import { BlockInstanceProps } from '../Block';
import CueCardGrid from '../../components/CueCardGrid';
import {
  BackgroundColorEnum,
  ContentTypeEnum,
} from '../../constants/cms-constants';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';

@ControlOption([
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  { key: 'withLinks', definition: controlOptionDefinitions.boolean },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class CueCardGridBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const withLinks = controlOptions?.withLinks;
    const seoWeight = controlOptions?.seoWeight;

    let mediaItems;
    blockContent.doQuery((content) => {
      mediaItems = content.getAllOfType(ContentTypeEnum.MEDIAITEM);
    });

    return (
      <CueCardGrid
        mediaItems={mediaItems}
        backgroundColor={backgroundColor}
        withLinks={withLinks}
        seoWeight={seoWeight}
      />
    );
  }
}

export default CueCardGridBlock;
